import { Box, Flex } from 'reflexbox';

import { Card, Heading3, Paragraph, Skeleton, tokens } from '@treams/treams-ui';

export function TreamsScoreAnalyticsLoading() {
	return (
		<>
			<Card style={{ overflow: 'visible' }}>
				<Heading3.Skeleton width={300} mb={2} />
				<Paragraph.Skeleton width={500} lines={1} />

				<Flex
					mt={4}
					flexDirection={['column', 'column', 'row']}
					alignItems={['stretch', 'stretch', 'center']}
					style={{ gap: 24 }}
				>
					<Flex
						flexDirection="column"
						alignItems="center"
						justifyContent="center"
						width={['100%', '100%', '240px']}
						style={{ flexShrink: 0, gap: 12 }}
					>
						<Skeleton.Box style={{ width: 120, height: 56 }} />
						<Skeleton.Box style={{ width: 80, height: 20 }} />
						<Skeleton.Box style={{ width: 140, height: 26, borderRadius: 100 }} />
					</Flex>

					<Box flexGrow={1} minWidth={0}>
						<Skeleton.Box style={{ width: '100%', height: 220 }} />
					</Box>
				</Flex>
			</Card>

			<Card mt={`${tokens.gap.section}px`}>
				<Heading3.Skeleton mb={3} />
				<Skeleton.Repeat count={6}>
					<Skeleton.Box height={48} mb={2} />
				</Skeleton.Repeat>
			</Card>
		</>
	);
}
